var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamElektr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.65 162.9",
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 8px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M91.65,4h13.66c10.12,0,18.34,8.22,18.34,18.34v.32c0,10.12-8.22,18.34-18.34,18.34h-13.66V4h0Z",
    transform: "translate(215.31 45) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 149.65,
    y1: 33,
    x2: 123.65,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 149.65,
    y1: 12,
    x2: 123.65,
    y2: 12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 69.73,
    y1: 145.82,
    x2: 132.07,
    y2: 146.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M145.16,108.87l-94.83-5.58-29.38-17.54c-3.89-2.32-6.29-6.54-6.29-11.07v-18.84c0-18.42,14.93-33.35,33.35-33.35h43.65"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 41.25,
    cy: 142.74,
    r: 16.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 159.78,
    cy: 142.74,
    r: 16.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M47.75,81.67l2.49-3.56c4.52-4.52,10.66-7.06,17.05-7.06h51.23c6.03,0,11.83,2.31,16.22,6.45l25.04,23.67,39.25,13.08,4.62,16.93v15.39h-8.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M14.25,145.82H7.39l-3.34-17.23c-.51-2.62,2.83-12.83,5.12-19.4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamElektr);
export default __webpack_public_path__ + "static/media/sam_elektr.70393ac18b499843bbba37ff3e5ab897.svg";
export { ForwardRef as ReactComponent };